module.exports = __webpack_public_path__ + "img/Plota.c4ff5bcb.jpeg";